import UserPreferencesMigrator from './UserPreferencesMigrator';

export default UserPreferencesMigrator;
